
import ChatRepository from "./ChatRepository";
import AuthRepository from "./AuthRepository";
import TarifRepository from "./TarifRepository";
import BasicRepository from "./BasicRepository";
import UserRepository from "./UserRepository";
import GuestRepository from "./GuestRepository";

const repositories = {

    chat: ChatRepository,
    auth: AuthRepository,
    tarif: TarifRepository,
    basic: BasicRepository,
    user: UserRepository,
    guest: GuestRepository,


};

export const RepositoryFactory = {
    get: name => repositories[name]
};
